import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { tampleteIndustryEditRoute } from '@features/enterprise/api/constants';
import { errorMessage, Timezone } from '@features/profile';
import axiosInstance from '@server/axiosInstance';
import { templateList } from '../constants';

type useEditIndustryTemplateProps = {
    setErrorText?: Dispatch<SetStateAction<string>>;
};

type EditTemplateVariables = {
    etemplate_id: number
    industry_id?: string | number
}

export const useEditIndustryTemplate = ({
    setErrorText = () => { },
}: useEditIndustryTemplateProps) => {
    const client = useQueryClient();

    const { mutate: editIndustry, isLoading: isUpdatingIndustry } =
        useMutation({
            mutationFn: (variables: EditTemplateVariables) =>
                axiosInstance
                    .post(tampleteIndustryEditRoute, variables)
                    .then((res) => res.data),
            onSuccess: (data) => {
                if (data.status !== 200) {
                    setErrorText(data.message);
                } else {
                    setErrorText('');
                    client.invalidateQueries([templateList]);
                }
            },
            onError: () => setErrorText(errorMessage),
        });

    return {
        editIndustry,
        isUpdatingIndustry,
    };
};
